import React from 'react';
import '@/styles/globals.scss';

import AuthWrapper from '@/components/auth/authWrapper';
import { FlagsProviderWrapper } from '@/components/flags/flagsProviderWrapper';
import { Sidebar } from '@/components/sidebar/sidebar';

import Providers from './providers';

export default function RootLayout( { children }: Readonly<{ children: React.ReactElement }> ) {
  return (
    <Providers>
      <AuthWrapper>
        <FlagsProviderWrapper>
          <Sidebar />
          <main>
            { children }
          </main>
        </FlagsProviderWrapper>
      </AuthWrapper>
    </Providers>
  );
}
